<template>
  <div
    class="w-full h-full bg-[#BDBDBD]"
    :class="layoutClass"
  >
    <div class="fixed inset-0 [overflow:clip]">
      <div class="w-[100vw] h-[100vh]">
        <TheHeader />

        <div class="w-full h-full flex">
          <div
            class="flex-grow mt-[60px] h-[calc(100%-60px)] overflow-auto"
            style="scrollbar-gutter: stable"
          >
            <router-view />
          </div>
        </div>

        <SupportChat v-if="route.path !== '/chatmessage'" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import TheHeader from './TheHeader.vue'
import { SupportChat } from '@/widgets/SupportChat'

const route = useRoute()

const layoutClass = computed(() => {
  const rec = [...route.matched].reverse().find(r => r.meta?.layoutClass)
  return rec?.meta.layoutClass ?? 'bg-[#BDBDBD]' // дефолт
})
</script>
